import { tamarackAPI, processApiResponse } from "./Tamarack";

export const UsStatesDataAPI = {
	async getUsStates() {
		const path = `usStates`;
		const response = await tamarackAPI.get(path);
		return processApiResponse(response, "get", path);
	},
};
